import React, { useState } from 'react';
import {
	AppBar,
	Box,
	Grid,
	IconButton,
	Typography,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import Logo from '../assets/images/Logo.png';
import { HelpCircle, SettingsIcon } from '../assets/icons/Icons';
import Avatar from '../assets/images/Avatar.png';
import TopBarDropdownMenu from './TopBarDropdownMenu';
import UserGuidePopup from './UserGuidePopup';
import { useNavigate } from 'react-router-dom';
import { getUserRole } from '../Utils/AuthUtil';
import { USER_ROLES } from '../Utils/Enums';

function TopNavigationBar(props) {
	const theme = useTheme();
	const navigator = useNavigate();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const [isUserGuideDialogOpen, setIsUserGuideDialogOpen] = useState(false);

	function onCloseUserGuideDialog() {
		setIsUserGuideDialogOpen(false);
	}

	function onOpenUserGuideDialog() {
		setIsUserGuideDialogOpen(true);
	}

	function isThisAppUser(params) {
		return parseInt(getUserRole()) !== USER_ROLES.superAdmin;
	}

	function getCurrentUserRole() {
		const role = parseInt(getUserRole());
		if (role === USER_ROLES.superAdmin) {
			return 'Super Admin';
		} else if (role === USER_ROLES.admin) {
			return 'Admin';
		} else if (role === USER_ROLES.staff) {
			return 'Staff';
		}

		return 'N/A';
	}

	function onLogout() {
		localStorage.clear();
		navigator('/');
	}

	return (
		<AppBar
			position="fixed"
			sx={{
				width: `calc(100% - ${props.drawerWidth}px)`,
				ml: `${props.drawerWidth}px`,
			}}
			style={{ backgroundColor: '#f1f9f8' }}
			elevation={0}>
			<Grid
				container
				style={{ paddingLeft: '7px', backgroundColor: '#FFFFFF' }}>
				{isMobile ? (
					<IconButton disableRipple onClick={props.onClickLogo}>
						<Box
							component={'img'}
							src={Logo}
							sx={{
								padding: '2px',
								backgroundColor: '#FFFFFF',
								borderRadius: '5px',
							}}
							width={180}
							height={45}
						/>
					</IconButton>
				) : (
					<Grid
						container
						flexDirection={'row'}
						alignItems={'center'}
						paddingLeft={'8px'}
						justifyContent={'space-between'}
						height={'50px'}>
						<IconButton
							disableRipple
							onClick={props.onClickLogo}
							width={'30%'}
							sx={{ padding: 0 }}>
							<Box
								component={'img'}
								src={Logo}
								sx={{
									padding: '2px',
									backgroundColor: '#FFFFFF',
									borderRadius: '5px',
								}}
								width={180}
								height={45}
							/>
						</IconButton>
						<Grid
							container
							width={'20%'}
							flexDirection={'row'}
							marginRight={'20px'}
							justifyContent={'flex-end'}
							alignItems={'center'}>
							{isThisAppUser() && (
								<IconButton
									disableRipple
									sx={{ padding: '5px' }}
									onClick={onOpenUserGuideDialog}>
									<HelpCircle />
								</IconButton>
							)}
							<IconButton
								disableRipple
								sx={{ padding: '5px' }}
								onClick={props.handleClick}>
								<Box
									component={'img'}
									src={Avatar}
									width={36}
									height={36}
								/>
							</IconButton>
							<TopBarDropdownMenu
								anchorEl={props.anchorEl}
								open={props.open}
								handleClose={props.handleClose}
								onLogout={onLogout}
								userRole={getCurrentUserRole()}
							/>
						</Grid>
					</Grid>
				)}
			</Grid>
			<UserGuidePopup
				isModalOpen={isUserGuideDialogOpen}
				onClose={onCloseUserGuideDialog}
			/>
		</AppBar>
	);
}

export default TopNavigationBar;
